<template>
	<v-card color="contained">
		<v-card-text>
			<img :src="qrCode" style="height: 256px; width: auto" />
			<p style="text-align: center; font-size: large; font-weight: bold">Call: {{ compProps.telephoneNumber }}</p>
		</v-card-text>
	</v-card>
</template>

<script setup lang="ts">
const compProps = defineProps({
	qrCode: String,
	telephoneNumber: String,
});
</script>
